import { useTranslation } from "react-i18next";
import type { Theme } from "../../theme/useTheme";
import styles from "./BrandLogo.module.css";

const iconByTheme: Record<Theme, string> = {
  light: "/brand/rws_logos_rws_logo_icon_rgb.png",
  dark: "/brand/rws_logos_rws_logo_icon_rgb.png",
};

/**
 * Renders the product brand with the RWS icon and the product name, while keeping the icon/logo
 * portion intact and replacing the old wordmark text with the product branding.
 *
 * @param props.theme - The active theme, used to keep the icon in the correct contrast context.
 * @param props.compact - Shows the icon alone, leaving the product name to screen readers, when the header needs the room.
 */
export function BrandLogo({ theme, compact = false }: { theme: Theme; compact?: boolean }): React.JSX.Element {
  const { t } = useTranslation();
  const productName = t("app.name").replace(/^RWS\s+/i, "");

  return (
    <div className={styles.brandLockup} aria-label={t("app.name")}>
      <img src={iconByTheme[theme]} alt="" aria-hidden="true" className={styles.logoIcon} />
      <span className={compact ? "visually-hidden" : styles.brandText}>{productName}</span>
    </div>
  );
}
